import styled from 'styled-components'

export const ComplementaryProductsContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: auto;

  scrollbar-color: ${({ theme }) => theme.colors.secondary}
    ${({ theme }) => theme.colors.background};
  scrollbar-width: thin;
`
